import React from 'react';

import { ListItem, ListItemIcon } from '@mui/material';

import { Check } from 'lucide-react';

import PropTypes from 'prop-types';

import { TypoWhite } from '../../../Components/Typo';

const ListItemAreYouProf = ({ children }) => (
  <ListItem disableGutters sx={{ alignItems: 'flex-start' }}>
    <ListItemIcon sx={{ minWidth: 38, mt: '3px' }}>
      <Check color='#ffffff' strokeWidth={2.4} size={20} />
    </ListItemIcon>
    <TypoWhite variant='body1'>{children}</TypoWhite>
  </ListItem>
);

ListItemAreYouProf.propTypes = {
  children: PropTypes.node,
};

export default React.memo(ListItemAreYouProf);
